export const DEFAULT_WIDTH = 470;
export const DEFAULT_HEIGHT = 300;
